import React, { useState } from 'react'
import { IApplication } from 'core/interfaces/Application'
import { ReactComponent as AppPublicationIcon } from 'core/assets/images/icones/appPublication.svg'
import { FormPublicationApplicationModal } from 'lauria/components/applications/FormPublicationApplicationModal'
import { IconComponent } from 'core/components/common/IconComponent'

interface PromptHeaderProps {
  application: IApplication
}

export const ApplicationHeaderMobile: React.FC<PromptHeaderProps> = ({
  application,
}) => {
  const { nomApplication, service } = application

  const [openPublication, setOpenPublication] = useState<boolean>(false)

  const openModalPublication = () => {
    setOpenPublication(true)
  }

  return (
    <div className="prompt-header">
      <div className="flex flex-row">
        <IconComponent
          iconInfo={application.service.icone}
          className="h-[40px] w-[40px]"
        />
        <div className="flex flex-col ml-10px">
          <div className="uppercase text-gray-1250">{service?.nomService}</div>
          <div className="font-medium">{nomApplication}</div>
        </div>
      </div>
      <div className="md:hidden">
        <div
          className={`btn-publication ${application.publiee ? 'publiee' : 'non-publiee'}`}
          onClick={openModalPublication}
        >
          <AppPublicationIcon className="h-[20px] mr-[5px]" />
        </div>
      </div>
      <FormPublicationApplicationModal
        open={openPublication}
        setOpen={setOpenPublication}
        application={application}
      />
    </div>
  )
}
